import React from 'react';
import { Link } from 'dva/router';
import { Result,Button } from 'antd';

export default () => (
  <Result
    status="404"
    title="404"
    subTitle="对不起，您访问的页面不存在。"
    extra={
      <Button type="primary">
        返回首页
      </Button>
    }
  ></Result>
);
